module.exports = __webpack_public_path__ + "static/media/hiw-alone3.e404b7ec.svg";